import { defineComponent as x, useAttrs as $, ref as d, watchEffect as B, computed as f, createElementBlock as a, openBlock as n, mergeProps as p, createElementVNode as o, createVNode as m, unref as h, createCommentVNode as u, renderSlot as s, normalizeClass as _, normalizeStyle as E, withCtx as V } from "vue";
import { useResizeObserver as z } from "@vueuse/core";
import N from "../../icons/generated/IconChevronDown.vue2.js";
import { tw as v } from "../../utils/tailwind.js";
import R from "./components/TransitionContent.vue2.js";
const S = {
  key: 0,
  class: "mr-8 block size-24"
}, I = { class: "flex grow flex-col" }, T = { class: "flex grow flex-row items-start" }, F = { class: "text-action-default-hi body-1 w-full max-w-full" }, H = { class: "ml-auto block" }, L = {
  key: 0,
  class: "body-2 w-full max-w-full"
}, J = /* @__PURE__ */ x({
  name: "RevAccordionItem",
  inheritAttrs: !1,
  __name: "AccordionItem",
  props: {
    collapsed: { default: "auto" },
    wrapperAttrs: { default: () => ({}) },
    keepContentAlive: { type: Boolean, default: !1 },
    renderBody: { type: Boolean, default: !1 },
    disableChevronAnimation: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(l, { emit: g }) {
    const i = l, y = g, b = $(), t = d(!1);
    B(() => {
      const e = {
        auto: !1,
        expanded: !0,
        collapsed: !1
      };
      t.value = e[i.collapsed];
    });
    const w = f(() => i.collapsed === "auto");
    function C(e) {
      y("click", e), w.value && (t.value = !t.value);
    }
    const k = f(() => i.disableChevronAnimation ? "" : [
      v`transition-transform duration-200 ease-in`,
      t.value && v`rotate-180`
    ]), r = d(), c = d(t.value ? "auto" : "0px");
    function A(e) {
      t.value || (e.setAttribute("style", "height: 0px"), c.value = "0px");
    }
    return z(r, () => {
      t.value && (c.value = `${r.value.getBoundingClientRect().height}px`);
    }), (e, O) => (n(), a("li", p(l.wrapperAttrs, { class: "relative list-none tap-highlight-transparent" }), [
      o("button", p(h(b), {
        class: "bg-static-default-min text-static-default-low focus-visible-outline-default-hi flex w-full cursor-pointer items-start overflow-hidden rounded-none border-0 px-24 py-20 text-left no-underline hover:bg-static-default-min-hover motion-safe:transition motion-safe:duration-200",
        onClick: C
      }), [
        e.$slots.prefix ? (n(), a("span", S, [
          s(e.$slots, "prefix")
        ])) : u("", !0),
        o("span", I, [
          o("span", T, [
            o("span", F, [
              s(e.$slots, "title")
            ]),
            o("span", H, [
              e.$slots.image ? u("", !0) : (n(), a("span", {
                key: 0,
                class: _(["block h-24", k.value])
              }, [
                m(h(N))
              ], 2)),
              s(e.$slots, "image")
            ])
          ]),
          e.$slots.description ? (n(), a("span", L, [
            s(e.$slots, "description")
          ])) : u("", !0)
        ])
      ], 16),
      m(R, {
        class: "text-static-default-mid body-2",
        condition: t.value,
        "keep-alive": l.keepContentAlive,
        "render-body": l.renderBody,
        style: E({ height: c.value }),
        "transition-props": {
          enterActiveClass: "overflow-y-hidden transition-height duration-300 ease-in will-change-[height]",
          enterFromClass: "h-0",
          leaveActiveClass: "overflow-y-hidden transition-height duration-300 ease-in will-change-[height]",
          leaveToClass: "h-0"
        },
        onLeave: A
      }, {
        default: V(() => [
          o("div", {
            ref_key: "accordionContentEl",
            ref: r,
            class: "px-24 pb-20 pt-8"
          }, [
            s(e.$slots, "body")
          ], 512)
        ]),
        _: 3
      }, 8, ["condition", "keep-alive", "render-body", "style"])
    ], 16));
  }
});
export {
  J as default
};
